/**
 * TourVideo (v35.44) — narrated full-application tour, embedded on Landing.
 * MP4 produced by scripts/produce_tour_video.py (ElevenLabs narration +
 * live app captures). Served from /videos/cartieai-tour.mp4.
 */
import React from 'react';
import { Download, PlayCircle } from 'lucide-react';

export const TourVideo = () => (
  <section className="py-20 px-4 bg-slate-950" data-testid="tour-video-section">
    <div className="max-w-5xl mx-auto">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
        <div>
          <p className="text-[11px] font-mono uppercase tracking-widest text-emerald-400 mb-3 flex items-center gap-2">
            <PlayCircle className="w-3.5 h-3.5" /> Guided tour · narrated · 9 min
          </p>
          <h2 className="text-base md:text-lg font-bold text-white">
            Watch the full tour — every engine, in one sitting.
          </h2>
          <p className="text-sm text-slate-400 mt-2 max-w-xl">
            The whole platform, narrated: the 60-second /try demo, the Auto-Compiler
            Proxy, all 26 engines, public forecast grading, and the 3× ROI pledge.
          </p>
        </div>
        <a
          href="/videos/cartieai-tour.mp4"
          download="cartieai-tour.mp4"
          className="inline-flex items-center gap-2 text-xs font-semibold text-slate-200 ring-1 ring-slate-700 hover:ring-emerald-500/50 hover:text-emerald-300 rounded-lg px-4 py-2.5 transition-colors"
          data-testid="tour-video-download"
        >
          <Download className="w-3.5 h-3.5" /> Download MP4
        </a>
      </div>
      <div className="rounded-2xl overflow-hidden ring-1 ring-slate-800 shadow-2xl shadow-emerald-500/5">
        <video
          controls
          preload="none"
          poster="/videos/cartieai-tour-poster.jpg"
          className="w-full aspect-video bg-black"
          data-testid="tour-video-player"
        >
          <source src="/videos/cartieai-tour.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  </section>
);

export default TourVideo;
